<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 초기화 시 필요한 작업을 할 수 있습니다.
  }
};
</script>

<style>
/* 여기에 필요한 CSS 스타일을 추가하세요 */
</style>
